// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__A_62W","infoContainer":"styles_infoContainer__2SllI","heading":"styles_heading__SERTI","content":"styles_content__6fRgc","root":"styles_root__vdumz"};